import React from "react";
import Datepicker from "react-datepicker";
import PropTypes from "prop-types";
import { dMMMyyyy } from "../../utils/constants/appConstants";
import "react-datepicker/dist/react-datepicker.css";
import Style from "./datepicker.module.scss";
import "./nextPrevArrow.scss";

const DatePickerSelectedDate = ({ placeholder, minDate, value, onChange }) => {
  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
      name="datepicker-input"
      className={Style.datepicercustom}
      onClick={onClick}
      value={value}
      placeholder={placeholder}
      readOnly
      ref={ref}
      autoComplete="off"
    />
  ));

  CustomInput.displayName = "CustomInput";
  CustomInput.propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func
  };

  return (
    <Datepicker
      selected={value}
      onChange={(date) => onChange(date)}
      minDate={minDate}
      dateFormat={dMMMyyyy}
      customInput={<CustomInput />}
    />
  );
};

DatePickerSelectedDate.propTypes = {
  placeholder: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired
};

export default DatePickerSelectedDate;
